import { render, staticRenderFns } from "./TermServiceCustomer.vue?vue&type=template&id=47473874&scoped=true"
import script from "./TermServiceCustomer.vue?vue&type=script&lang=js"
export * from "./TermServiceCustomer.vue?vue&type=script&lang=js"
import style0 from "./TermServiceCustomer.vue?vue&type=style&index=0&id=47473874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47473874",
  null
  
)

export default component.exports